var map = {
	"./flower1.png": 96,
	"./flower2.png": 97,
	"./flower3.png": 98,
	"./flower4.png": 99,
	"./flower5.png": 100,
	"./flower6.png": 101,
	"./flower7.png": 102,
	"./flower8.png": 103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;